export interface RoleRight {
  __type?: string;
  IsAppear: boolean;
  MenuId: string;
  MenuName: string;
  IsAddAllowed: boolean;
  IsUpdateAllowed: boolean;
  IsDeleteAllowed: boolean;
  IsPrintAllowed: boolean;
  IsViewAllowed: boolean;
}

export interface SpecialRole {
  RoleName: string;
  RoleDescription: string;
  AccessAllData: boolean;
  ViewAllMenu: boolean;
  ViewBirthDayOnDashBoard: boolean;
  ViewBuyerOrderReportOnDashBoard: boolean;
  AllowWithoutMinimumDeposit: boolean;
  ViewCampaignLink: boolean;
}

export interface CrmRoleRight {
  CrmRoleRight: RoleRight[];
  CrmSpecialRole: SpecialRole;
}

export interface RoleRequest {
  RoleId: string;
  RoleName: string;
  Description: string;
  AccessAllData: boolean;
  ViewAllMenu: boolean;
  ViewBirthDayOnDashBoard: boolean;
  ViewBuyerOrderReportOnDashBoard: boolean;
  AllowWithoutMinimumDeposit: boolean;
  ViewCampaignLink: boolean;
  RightsList: RoleRight[];
}

